import './bootstrap';
import './bootstrap-datepicker';
import 'alpinejs';
import jspreadsheet from 'jspreadsheet-ce';
import 'jsuites';
import './custom';
import 'feather-icons';
import calculator from './smartTuningCalculator';
import Alpine from 'alpinejs';
import {createApp} from "vue";
import ExampleComponent from './components/ExampleComponent.vue';


window.jspreadsheet = jspreadsheet;

const app = createApp({});

app.component('example-component', ExampleComponent);

app.mount('#app');
window.Alpine = Alpine;
window.calculator = calculator;
window.Alpine = Alpine;

Alpine.start();
